<template>
    <div id="search-input">
        <icon name="search" scale=".8" color="var(--secondary-3)" />
        <input type="text" :placeholder="(placeholder ? placeholder : this.$t('keyword167')) + '...'" v-model="search" />

        <div v-if="search" class="clear-container" @click="search = null">
            <icon name="times-circle" scale=".8" color="var(--secondary-3)" />
        </div>
    </div>
</template>
<script>
import 'vue-awesome/icons/search'
import 'vue-awesome/icons/times-circle'

export default {
    name: 'CustomSearchInput',

    props: {
        placeholder: {
            type: String,
        },
    },

    watch: {
        search() {
            this.$emit('input', this.search)
        },
    },

    data() {
        return {
            search: null,
        }
    },
}
</script>
<style lang="scss" scoped>
#search-input {
    width: 100%;
    background-color: var(--primary-1);
    height: 24px;
    display: flex;
    align-items: center;
    padding: 0 8px;
    border-radius: 4px;
    input {
        margin-left: 8px;
        height: 100%;
        border: none;
        background: transparent;
        font-size: 12px;
        width: 100%;
        outline: none;
        color: var(--light);
    }

    .clear-container {
        cursor: pointer;
    }
}
</style>
